var SelectPayModalState;
(function (SelectPayModalState) {
    SelectPayModalState["complete"] = "complete";
    SelectPayModalState["confirm"] = "confirm";
    SelectPayModalState["default"] = "default";
    SelectPayModalState["error"] = "error";
    SelectPayModalState["installments"] = "installments";
    SelectPayModalState["review"] = "review";
    SelectPayModalState["errorLimitReached"] = "errorLimitReached";
    SelectPayModalState["errorDisputes"] = "errorDisputes";
})(SelectPayModalState || (SelectPayModalState = {}));
export default SelectPayModalState;
//# sourceMappingURL=select-pay-types.js.map